/**
 * Tri-state aggregate for a parent header's channel checkbox.
 *
 * Walks `indices` into `alarms` and counts how many have
 * `[channelKey]` truthy.  Returns `{checked, indeterminate}` for
 * the parent's `<Checkbox>`:
 *
 *   - all on  → `{checked: true,  indeterminate: false}`
 *   - all off → `{checked: false, indeterminate: false}`
 *   - mixed   → `{checked: false, indeterminate: true}`
 */
export default function aggregateChannel(alarms, indices, channelKey) {
  if (indices.length === 0) return { checked: false, indeterminate: false };
  let on = 0;
  for (const idx of indices) {
    if (alarms[idx]?.[channelKey]) on += 1;
  }
  if (on === 0) return { checked: false, indeterminate: false };
  if (on === indices.length) return { checked: true, indeterminate: false };
  return { checked: false, indeterminate: true };
}
